// extracted by mini-css-extract-plugin
module.exports = {"list_default":"style_list_default__Dz5xf","last_item":"style_last_item__KKkFk","social_media":"style_social_media__KtY9c"};